






























import CheckoutReviewOrderItemViewModel from "@/chipply/view-model/CheckoutReviewOrderItemViewModel";
import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { Utils } from "chipply-common";
import PriceDisplay from "./price/PriceDisplay.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: { PriceDisplay },
})
export default class OrderItemSimpleDisplay extends Vue {
    public name = "OrderItemSimpleDisplay";

    public Utils = Utils;

    @Prop({ default: false })
    public isRequestor!: boolean;

    @Prop({ default: {} })
    public item!: CheckoutReviewOrderItemViewModel;

    @Prop({ type: Object })
    public priceDisplay!: IPriceDisplay;

    public valueDisplayFunc = (priceArgs: number) => Utils.getCurrencyValue(priceArgs, false, true);

    public get mobile() {
        return this.$vuetify.breakpoint.smAndDown;
    }
}
